export const APP_READY = "APP_READY";

export const CASINO_GAMES_OPENED = "CASINO_GAMES_OPENED";
export const SWARM_CONFIG_DATA = "SWARM_CONFIG_DATA";

export const LOGGED_IN = "LOGGED_IN"; // login state in UI
export const LOGGED_OUT = "LOGOUT";
export const LOGIN_FAILED = "LOGIN_FAILED";
export const IS_ADMIN_LOGGED_IN = "IS_ADMIN_LOGGED_IN";
export const IS_CARD_REGISTERED = "IS_CARD_REGISTERED";
export const CLEAR_CARD_REGISTERED = "CLEAR_CARD_REGISTERED";
export const SET_VERIFICATION_INFO = "SET_VERIFICATION_INFO";
export const SET_FREE_BONUSES = "SET_FREE_BONUSES";

export const USER_PROFILE_UPDATE_RECEIVED = "USER_PROFILE_UPDATE_RECEIVED";
export const FINISH_REGISTRATION = "FINISH_REGISTRATION";

export const SET_TERMINAL_SUPERBET_DATA = "SET_TERMINAL_SUPERBET_DATA";
export const TOGGLE_ADMIN_PAGE_BLOCK_STATUS = "TOGGLE_ADMIN_PAGE_BLOCK_STATUS";

// non-persistent UI
export const SAVE_POPUP_TIMER = "SAVE_POPUP_TIMER";
export const TOGGLE_POPUP_TIMER = "TOGGLE_POPUP_TIMER";
export const TICKET_SCAN = "TICKET_SCAN";
export const CHECK_CASHOUT_TICKET = "CHECK_CASHOUT_TICKET";
export const CHECKED_TICKETS = "CHECKED_TICKETS";
export const DATA_FINISHED = "DATA_FINISHED";

export const OPEN_IDLE_POPUP = "OPEN_IDLE_POPUP";
export const CLOSE_IDLE_POPUP = "CLOSE_IDLE_POPUP";

export const LOYAL_CARD = "LOYAL_CARD";
export const SET_LOYAL_CARD_INPUT_ACTIVE = "SET_LOYAL_CARD_INPUT_ACTIVE";

export const REGISTER_MODE = "REGISTER_MODE";
export const SET_DEPOSIT_MODE = "SET_DEPOSIT_MODE";

// Terminal actions
export const SET_TERMINAL_ACUMULATOR_BONUSE = "SET_TERMINAL_ACUMULATOR_BONUSE";
export const ADD_TO_BALANCE = "ADD_TO_BALANCE";
export const TITO_ACCEPT_BET = "TITO_ACCEPT_BET";
export const TITO_CASHOUT_BET = "TITO_CASHOUT_BET";
export const PRINT_TICKET = "PRINT_TICKET";
export const PRINT_BET_BUILDER_TICKET = "PRINT_BET_BUILDER_TICKET";
export const PRINT_LOTTERY_TICKET = "PRINT_LOTTERY_TICKET";
export const PRINT_CLIENT_TICKET = "PRINT_CLIENT_TICKET";
export const SHOW_LAST_BETS_LIST = "SHOW_LAST_BETS_LIST";
export const CLEAR_LAST_BETS_LIST = "CLEAR_LAST_BETS_LIST";
export const TITO_ACCEPT_CASHOUT = "TITO_ACCEPT_CASHOUT";
export const PAY_CASINO_LOTTERY_WIN_TICKET = "PAY_CASINO_LOTTERY_WIN_TICKET";
export const GET_SUPERBET_TICKET_BY_ID = "GET_SUPERBET_TICKET_BY_ID";
export const SET_SUPERBET_ID = "SET_SUPERBET_ID";
export const REJECT_SUPERBET = "REJECT_SUPERBET";
export const CASHOUT_MONEY = "CASHOUT_MONEY";
export const PARTIAL_CASHOUT_MONEY = "PARTIAL_CASHOUT_MONEY";
export const CASHOUT_MONEY_CASH = "CASHOUT_MONEY_CASH";
export const CASHOUT_MONEY_WITH_FEE = "CASHOUT_MONEY_WITH_FEE";
export const CASHOUT_CLIENT_MONEY = "CASHOUT_CLIENT_MONEY";
export const PRINT_BOOKING_TICKET = "PRINT_BOOKING_TICKET";
export const TERMINAL_ERROR = "TERMINAL_ERROR";
export const SEND_LOGS = "SEND_LOGS";
export const LOCK_TERMINAL = "LOCK_TERMINAL";
export const UNLOCK_TERMINAL = "UNLOCK_TERMINAL";
export const HIDE_TERMINAL_ERROR = "HIDE_TERMINAL_ERROR";
export const SET_POPUP_LAUNCHER = "SET_POPUP_LAUNCHER";
export const SET_LANGUAGE = "SET_LANGUAGE";
export const LOGIN_ADMIN = "LOGIN_ADMIN";
export const SET_BALANCE = "SET_BALANCE";
export const SET_PROFILE_ERROR = "SET_PROFILE_ERROR";
export const RESET_UI_BY_IDLE_TIMER = "RESET_UI_BY_IDLE_TIMER";
export const SET_CURRENCY = "SET_CURRENCY";
export const SHOW_KEYBOARD = "SHOW_KEYBOARD";
export const SET_TERMINAL_AUTH_DATA = "SET_TERMINAL_AUTH_DATA";
export const SET_TERMINAL_USAGE_CONFIRMED = "SET_TERMINAL_USAGE_CONFIRMED";
export const SET_STARTUP_SETTINGS = "SET_STARTUP_SETTINGS";
export const SET_TERMINAL_BALANCE = "SET_TERMINAL_BALANCE";
export const SET_TAX = "SET_TAX";
export const USER_DID_LOGIN = "USER_DID_LOGIN";
export const USER_DID_LOGOUT = "USER_DID_LOGOUT";
export const MOUSE_MOVE_POSITION = "MOUSE_MOVE_POSITION";
export const SET_DEPOSIT_BALANCE = "SET_DEPOSIT_BALANCE";
export const CONFIRM_REGISTRATION_NEW_CARD = "CONFIRM_REGISTRATION_NEW_CARD";
export const UPDATE_PLAYER_CARD_ID = "UPDATE_PLAYER_CARD_ID";
export const PARTIAL_DEPOSIT_TO_CLIENT_ACCOUNT = "PARTIAL_DEPOSIT_TO_CLIENT_ACCOUNT";
export const DEPOSIT_TO_CLIENT_ACCOUNT = "DEPOSIT_TO_CLIENT_ACCOUNT";
export const SET_VERIFICATION_RESPONSE = "SET_VERIFICATION_RESPONSE";

export const ADMIN_USER_COMMANDS = "ADMIN_USER_COMMANDS";
export const RFID_REGISTER_MODE = "RFID_REGISTER_MODE";

export const DEPOSIT = "DEPOSIT";

export const PRINT_ONE_TIME_PASSWORD = "PRINT_ONE_TIME_PASSWORD";

export const GET_PLAYER_INFO = "GET_PLAYER_INFO";
export const START_COLLECT_DEPOSIT_MONEY = "START_COLLECT_DEPOSIT_MONEY";
export const FINISH_COLLECT_DEPOSIT_MONEY = "FINISH_COLLECT_DEPOSIT_MONEY";
export const GET_DEPOSIT_RECORDS = "GET_DEPOSIT_RECORDS";
export const PRINT_DEPOSIT_TICKET_BY_ID = "PRINT_DEPOSIT_TICKET_BY_ID";
export const GET_WITHDRAWAL_REQUESTS = "GET_WITHDRAWAL_REQUESTS";
export const VALIDATE_WITHDRAWAL_PIN = "VALIDATE_WITHDRAWAL_PIN";
export const PAY_WITHDRAWAL_REQUEST = "PAY_WITHDRAWAL_REQUEST";

export const CHECK_ONE_TIME_LOGIN = "CHECK_ONE_TIME_LOGIN";
export const END_VERIFICATION_SESSION = "END_VERIFICATION_SESSION";
export const RESET_VERIFICATION_SESSION = "RESET_VERIFICATION_SESSION";
export const SET_BELGIAN_VERIFICATION_ERROR = "SET_BELGIAN_VERIFICATION_ERROR";

export const SET_MERCHANT_ID = "SET_MERCHANT_ID";
export const GET_MERCHANT_INFO = "GET_MERCHANT_INFO";

export const SET_LAST_MONEY_INPUT_TYPE = 'SET_LAST_MONEY_INPUT_TYPE'
export const SET_TERMINAL_DEPOSIT_MODE = 'SET_TERMINAL_DEPOSIT_MODE';
export const SET_MONEY_INPUT_ACTIVE = 'SET_MONEY_INPUT_ACTIVE';
export const INCREASE_LOCAL_BALANCE = 'INCREASE_LOCAL_BALANCE';
export const SET_PLAYER_PAYMENT_INFO = 'SET_PLAYER_PAYMENT_INFO';
export const RESET_PLAYER_PAYMENT_INFO = 'RESET_PLAYER_PAYMENT_INFO'
export const GET_BET_PLAYER_PAYEMNT_INFO_BULK = 'GET_BET_PLAYER_PAYEMNT_INFO_BULK';
export const GET_SAVED_PLAYER_PAYMENT_INFO = 'GET_SAVED_PLAYER_PAYMENT_INFO'
export const SAVE_PLAYER_PAYMENT_INFO = 'SAVE_PLAYER_PAYMENT_INFO'
export const RECEIVE_SAVED_PLAYER_PAYMENT_INFO = 'RECEIVE_SAVED_PLAYER_PAYMENT_INFO'
export const SET_PROFIT_BOOST_INFO = 'SET_PROFIT_BOOST_INFO'
export const SET_SPIN_TO_WIN_BET_ID = 'SET_SPIN_TO_WIN_BET_ID'